import { useState } from 'react'
import eye from '../../assets/icons/eyeBlack.svg'
import check from '../../assets/icons/check.svg'
import close from '../../assets/icons/close.svg'
import { AnimatePresence } from 'framer-motion'
import ApproveBalance from './balance/ApproveBalance'
import RejectBalance from './balance/RejectBalance'
import ViewBalance from './balance/ViewBalance'

const BalanceOrder = ({ row, index, refresh }) => {
  const [view, setView] = useState(false)
  const [approve, setApprove] = useState(false)
  const [reject, setReject] = useState(false)

  function formatDate(dateString) {
    const options = { year: '2-digit', month: '2-digit', day: '2-digit' }
    const date = new Date(dateString)
    return date.toLocaleDateString('en-GB', options)
  }

  return (
    <>
      <div className={`${index % 2 === 0 ? '' : ' bg-gray/20'} flex py-2`}>
        <div className="flex-1 p-2 items-center justify-center flex">
          {row.order_id}
        </div>
        <div className="flex-1 p-2 items-center text-center justify-center flex">
          {row.status || 'unknown'}
        </div>
        <div className="flex-1 p-2 items-center text-center justify-center flex">
          {row.client_name}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          {parseFloat(row.amount || 0).toFixed(2)}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          {formatDate(row.created_at)}
        </div>
        <div className="flex-1 flex p-2 items-center justify-center">
          {row.rejecting_employee_id || 'No'}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex gap-3">
          <button
            onClick={() => setView(true)}
            className="w-6 h-6 aspect-square flex text-blueButton rounded hover:bg-blue-600"
          >
            <span>
              <img src={eye} alt="" />
            </span>
          </button>
          {row.status !== 'Complete Successfully' && (
            <button
              onClick={() => setApprove(true)}
              className=" w-6 h-6 flex justify-center items-center rounded-sm  text-blueButton   aspect-square hover:bg-blue-600"
            >
              <span>
                <img src={check} alt="" />
              </span>
            </button>
          )}

          {row.status === 'new dept order' && (
            <>
              <button
                onClick={() => setReject(true)}
                className=" w-6 h-6 flex  justify-center items-center text-blueButton   aspect-square hover:bg-blue-600"
              >
                <span>
                  <img src={close} alt="" />
                </span>
              </button>
            </>
          )}
        </div>
      </div>

      <AnimatePresence>
        {view && (
          <ViewBalance order={row} active={view} close={() => setView(false)} />
        )}
        {approve && (
          <ApproveBalance
            refresh={refresh}
            order={row}
            active={approve}
            close={() => setApprove(false)}
          />
        )}
        {reject && (
          <RejectBalance
            refresh={refresh}
            order={row}
            active={reject}
            close={() => setReject(false)}
          />
        )}
      </AnimatePresence>
    </>
  )
}

export default BalanceOrder
